import type { TConstraints } from '@feathr/rachis';

import { createDimensionValidator, CreativeClass, ValidDimensions } from './creatives_base';
import type { ICreativeAuditStatus, IDisplayCreative } from './creatives_display';
import { DisplayCreative } from './creatives_display';

// =============================================================================
// Image Creative Types
// =============================================================================

export const VALID_IMAGE_FORMATS = ['image/jpeg', 'image/png', 'image/gif'];

export interface IImageCreative extends IDisplayCreative {
  readonly _cls: CreativeClass.DisplayImage;
  audit_statuses: ICreativeAuditStatus[];
}

// =============================================================================
// Image Creative Class
// =============================================================================

/**
 * ImageCreative handles static image display creatives.
 * Supports JPG, PNG, and GIF formats.
 */
export class ImageCreative extends DisplayCreative<IImageCreative> {
  public override readonly className = 'ImageCreative';

  public override get constraints(): TConstraints<IImageCreative> {
    return {
      ...super.constraints,
      _cls: {
        inclusion: [CreativeClass.DisplayImage],
      },
      mimetype: {
        inclusion: {
          within: VALID_IMAGE_FORMATS,
          message: '^File must be JPG, PNG, or GIF format',
        },
      },
      width: {
        ...super.constraints.width,
        equality: createDimensionValidator(ValidDimensions, 'width'),
      },
      height: {
        ...super.constraints.height,
        equality: createDimensionValidator(ValidDimensions, 'height'),
      },
    };
  }

  public override getDefaults(): Partial<IImageCreative> {
    return {
      ...super.getDefaults(),
      _cls: CreativeClass.DisplayImage,
    };
  }
}
